import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2563EB',
      light: '#3B82F6',
      dark: '#1D4ED8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#0F172A',
      light: '#334155',
      dark: '#020617',
      contrastText: '#ffffff',
    },
    success: {
      main: '#10B981',
      light: '#D1FAE5',
      dark: '#059669',
    },
    warning: {
      main: '#F59E0B',
      light: '#FEF3C7',
      dark: '#D97706',
    },
    error: {
      main: '#EF4444',
      light: '#FEE2E2',
      dark: '#DC2626',
    },
    info: {
      main: '#3B82F6',
      light: '#DBEAFE',
      dark: '#2563EB',
    },
    background: {
      default: '#F8FAFC',
      paper: '#ffffff',
    },
    text: {
      primary: '#0F172A',
      secondary: '#64748B',
    },
    divider: '#E2E8F0',
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: { fontSize: '2rem', fontWeight: 700, letterSpacing: '-0.025em', color: '#0F172A' },
    h2: { fontSize: '1.5rem', fontWeight: 700, letterSpacing: '-0.025em', color: '#0F172A' },
    h3: { fontSize: '1.25rem', fontWeight: 600, letterSpacing: '-0.01em', color: '#0F172A' },
    h4: { fontSize: '1.125rem', fontWeight: 600, color: '#0F172A' },
    h5: { fontSize: '1rem', fontWeight: 600, color: '#0F172A' },
    h6: { fontSize: '0.875rem', fontWeight: 600, color: '#0F172A' },
    body1: { fontSize: '0.9375rem', lineHeight: 1.6, color: '#334155' },
    body2: { fontSize: '0.8125rem', lineHeight: 1.5, color: '#64748B' },
    caption: { fontSize: '0.75rem', color: '#94A3B8', fontWeight: 500 },
    button: { fontWeight: 600, fontSize: '0.875rem' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          textTransform: 'none',
          fontWeight: 600,
          padding: '10px 20px',
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
        contained: {
          '&:hover': {
            boxShadow: '0 1px 3px 0 rgba(0,0,0,0.1), 0 1px 2px -1px rgba(0,0,0,0.1)',
          },
        },
        outlined: {
          borderColor: '#E2E8F0',
          color: '#334155',
          '&:hover': {
            borderColor: '#CBD5E1',
            backgroundColor: '#F8FAFC',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 1px 3px 0 rgba(0,0,0,0.04), 0 1px 2px -1px rgba(0,0,0,0.04)',
          border: '1px solid #E2E8F0',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 8, fontWeight: 500, fontSize: '0.75rem' },
        colorSuccess: { backgroundColor: '#D1FAE5', color: '#059669' },
        colorError: { backgroundColor: '#FEE2E2', color: '#DC2626' },
        colorWarning: { backgroundColor: '#FEF3C7', color: '#D97706' },
        colorInfo: { backgroundColor: '#DBEAFE', color: '#2563EB' },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            '& fieldset': { borderColor: '#E2E8F0' },
            '&:hover fieldset': { borderColor: '#CBD5E1' },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 16 },
        elevation1: { boxShadow: '0 1px 3px 0 rgba(0,0,0,0.04)' },
        elevation2: { boxShadow: '0 1px 3px 0 rgba(0,0,0,0.06), 0 1px 2px -1px rgba(0,0,0,0.06)' },
        elevation3: { boxShadow: '0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -2px rgba(0,0,0,0.05)' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.875rem',
          minHeight: 48,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 12 },
        standardInfo: { backgroundColor: '#EFF6FF', color: '#1E40AF' },
        standardSuccess: { backgroundColor: '#F0FDF4', color: '#166534' },
        standardWarning: { backgroundColor: '#FFFBEB', color: '#92400E' },
        standardError: { backgroundColor: '#FEF2F2', color: '#991B1B' },
      },
    },
  },
  spacing: 8,
});

export default theme;